import { useState, useEffect } from 'react';
import './App.css';
import { db, storage, auth, messaging } from './firebase'; 
import { 
  signInAnonymously, 
  updateProfile, 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  sendPasswordResetEmail
} from 'firebase/auth';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, setDoc, updateDoc } from 'firebase/firestore';
import Feed from './Feed';
import logo from './logo.png';
import OneSignal from 'react-onesignal';
import { SALDO_INICIAL_BOLAS } from './saldoUtilizador'; 

function App() {
  const [promptInstalacao, setPromptInstalacao] = useState(null);

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setPromptInstalacao(e);
    });
  }, []);

  const instalarApp = () => {
    if (!promptInstalacao) return;
    promptInstalacao.prompt();
    promptInstalacao.userChoice.then((choice) => {
      if (choice.outcome === 'accepted') setPromptInstalacao(null);
    });
  };

  useEffect(() => {
    // TRANCA GLOBAL: o OneSignal só pode ser inicializado UMA vez (StrictMode monta 2x)
      if (!window.oneSignalPromessa) {
      window.oneSignalPromessa = OneSignal.init({
        appId: "e92e9533-4698-44b3-8a09-533f57231e53",
        allowLocalhostAsSecureOrigin: true,
        notifyButton: { enable: true },
        serviceWorkerPath: 'sw.js',
        serviceWorkerUpdaterPath: 'sw.js',
        serviceWorkerParam: { scope: '/' }
      }).then(() => {
        return true;
      }).catch((erroOS) => {
        console.log("OneSignal já estava ativo:", erroOS);
        return true;
      });
    }

    const unsub = auth.onAuthStateChanged((user) => {
      if (user) {
        setLogado(true); // Aqui ele salta o botão de entrar e vai direto
        // Espera o motor do OneSignal arrancar antes de fazer login (evita o erro 'Qe')
        window.oneSignalPromessa.then(() => {
          OneSignal.login(user.uid);
          OneSignal.Notifications.requestPermission();
        }).catch((erroLoginOS) => {
          console.log("Erro no login do OneSignal:", erroLoginOS);
        });
      } else {
        setLogado(false);
        window.oneSignalPromessa.then(() => {
          OneSignal.logout();
        }).catch(() => {});
      }
      setAutenticando(false);
    });
    return () => unsub();
  }, []);

  const [nomeCompleto, setNomeCompleto] = useState(''); // Servirá para o Nickname no formulário
  const [dataNascimento, setDataNascimento] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fotoFicheiro, setFotoFicheiro] = useState(null);
  const [fotoPreview, setFotoPreview] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [logado, setLogado] = useState(false);
  const [erroIdade, setErroIdade] = useState(false);
  const [mostrarPassword, setMostrarPassword] = useState(false);
  const [modoLogin, setModoLogin] = useState(false);
  const [autenticando, setAutenticando] = useState(true);

  // Dicionário Dinâmico Multi-línguas para Expansão Mundial Automática
  const detetarIdioma = () => {
    const lang = navigator.language || navigator.userLanguage || 'en';
    return lang.startsWith('pt') ? 'pt' : lang.startsWith('es') ? 'es' : 'en';
  };

  const idiomas = {
    pt: {
      erroCampos: "Preenche os dados corretamente!",
      erroIdade: "Segurança: O valor mínimo para resgate é de 18 anos.",
      erroEmail: "Escreve o teu e-mail primeiro!",
      linkEnviado: "Link de recuperação enviado para o teu e-mail! ⚽",
      carregando: "GAME FUT LIVE..."
    },
    en: {
      erroCampos: "Please fill in all data correctly!",
      erroIdade: "Security: You must be at least 18 years old.",
      erroEmail: "Please enter your email first!",
      linkEnviado: "Password reset link sent to your email! ⚽",
      carregando: "GAME FUT LIVE..."
    },
    es: {
      erroCampos: "¡Por favor, rellena todos los datos correctamente!",
      erroIdade: "Seguridad: Debes tener al menos 18 años.",
      erroEmail: "¡Por favor, escribe tu correo primero!",
      linkEnviado: "¡Enlace de recuperación enviado a tu correo! ⚽",
      carregando: "GAME FUT LIVE..."
    }
  };

  const TEXTOS = idiomas[detetarIdioma()];

  const selecionarFoto = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFotoFicheiro(file);
      setFotoPreview(URL.createObjectURL(file));
    }
  };

  const verificarIdade = (data) => {
    setDataNascimento(data);
    const hoje = new Date();
    const nascimento = new Date(data);
    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const m = hoje.getMonth() - nascimento.getMonth();
    if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
      idade--;
    }
    setErroIdade(idade < 18);
  };

    const entrarNoJogo = async () => {
    const nicknameLimpo = nomeCompleto.trim().replace(/\s+/g, '_').toLowerCase();

    // BLINDAGEM DE SEGURANÇA: Recalcula a idade no motor interno para evitar fraudes na consola
    let idadeReal = 0;
    if (dataNascimento) {
      const hoje = new Date();
      const nascimento = new Date(dataNascimento);
      idadeReal = hoje.getFullYear() - nascimento.getFullYear();
      const m = hoje.getMonth() - nascimento.getMonth();
      if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
        idadeReal--;
      }
    }

    // Verifica se os dados estão vazios ou se tentaram falsificar a maioridade
    const utilizadorInvalido = !modoLogin && (idadeReal < 18 || !nicknameLimpo || !dataNascimento || !fotoFicheiro);
    const camposVazios = modoLogin ? (!email || !password) : (!email || !password);

    if (camposVazios || utilizadorInvalido) {
      // Usamos um aviso interno em vez do alert do sistema para evitar travamentos
      setErroIdade(idadeReal < 18);
      return;
    }
    
    setCarregando(true);
    try {
      let user;
      if (modoLogin) {
        const cred = await signInWithEmailAndPassword(auth, email, password);
        user = cred.user;
      } else {
        const cred = await createUserWithEmailAndPassword(auth, email, password);
        user = cred.user;

        const fotoRef = ref(storage, `perfis/${user.uid}`);
        await uploadBytes(fotoRef, fotoFicheiro);
        const urlFinal = await getDownloadURL(fotoRef);

        // Atualiza o perfil público com o Nickname limpo
        await updateProfile(user, { displayName: nicknameLimpo, photoURL: urlFinal });

              // CRIAÇÃO DA FICHA DE UTILIZADOR (Saldo inicializado a 0 por segurança contra hackers)
        await setDoc(doc(db, "utilizadores", user.uid), {
          uid: user.uid,
          nomeCompleto: nicknameLimpo,
          dataNascimento,
          fotoUrl: urlFinal,
          saldoBolas: 0, 
          criadoEm: new Date()
        });
      }
      setLogado(true);
        } catch (error) { 
      console.error("Erro no registo/login:", error.message); 
    }
    setCarregando(false);
  };

  const recuperarSenha = async () => {
    if (!email) { console.warn(TEXTOS.erroEmail); return; }
    try {
      await sendPasswordResetEmail(auth, email);
          console.log(TEXTOS.linkEnviado);
    } catch (error) { console.error("Erro na password:", error.message); }
  };

  if (autenticando) return <div style={{background: '#000', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#39FF14', fontWeight: 'bold', fontSize: '20px'}}>{TEXTOS.carregando}</div>;

      // Captura o link do WhatsApp para decidir se pula o ecrã de entrada
  const paramsDeArranque = new URLSearchParams(window.location.search);
  const postVindoDoLink = paramsDeArranque.get('postId');

  // Adicionamos os placeholders multi-línguas com suporte a Nickname
  const placeholdersIdiomas = {
    pt: {
      nickname: "Nickname ou Nome",
      email: "Teu E-mail",
      password: "Escolhe uma Password",
      dataNasc: "Data de Nascimento:",
      menorIdade: "ACESSO NEGADO: Menor de 18 anos.",
      maiorIdade: "Apenas para maiores de 18 anos.",
      confirmar: "CONFIRMAR E ENTRAR ⚽",
      processar: "A PROCESSAR...",
      criarConta: "Novo por aqui? Criar conta ⚽",
      entrarEstadio: "Já tens conta? Entrar no Estádio",
      termosUso: "Ao avançar, aceitas as Diretrizes do Estádio e Termos de Uso.",
      esqueciSenha: "Esqueci-me da password 🔒",
      fotoPerfil: "FOTO DE PERFIL",
      instalarTitulo: "QUERES O GAMEFUT NO TEU ECRÃ? ⚽",
      instalarBotao: "INSTALAR AGORA",
      instalarMaisTarde: "MAIS TARDE"
    },
    en: {
      nickname: "Choose a Nickname (e.g., striker_10)",
      email: "Your Email",
      password: "Choose a Password",
      dataNasc: "Date of Birth:",
      menorIdade: "ACCESS DENIED: Under 18 years old.",
      maiorIdade: "Only for users over 18 years old.",
      confirmar: "CONFIRM AND ENTER ⚽",
      processar: "PROCESSING...",
      criarConta: "New here? Create account ⚽",
      entrarEstadio: "Already have an account? Enter Stadium",
      termosUso: "By proceeding, you accept the Stadium Guidelines and Terms of Use.",
      esqueciSenha: "Forgot my password 🔒",
      fotoPerfil: "PROFILE PICTURE",
      instalarTitulo: "WANT GAMEFUT ON YOUR SCREEN? ⚽",
      instalarBotao: "INSTALL NOW",
      instalarMaisTarde: "LATER"
    },
    es: {
      nickname: "Elige un Nickname (ej: crack_10)",
      email: "Tu E-mail",
      password: "Elige una Contraseña",
      dataNasc: "Fecha de Nacimiento:",
      menorIdade: "ACCESO DENEGADO: Menor de 18 años.",
      maiorIdade: "Solo para mayores de 18 años.",
      confirmar: "CONFIRMAR Y ENTRAR ⚽",
      processar: "PROCESANDO...",
      criarConta: "¿Nuevo por aquí? Crear cuenta ⚽",
      entrarEstadio: "¿Ya tienes cuenta? Entrar al Estadio",
      termosUso: "Al avanzar, aceptas las Directrizes del Estadio y Términos de Uso.",
      esqueciSenha: "Olvidé mi contraseña 🔒",
      fotoPerfil: "FOTO DE PERFIL",
      instalarTitulo: "¿QUIERES GAMEFUT EN TU PANTALLA? ⚽",
      instalarBotao: "INSTALAR AHORA",
      instalarMaisTarde: "MÁS TARDE"
    }
  };

  const currentLang = navigator.language.startsWith('pt') ? 'pt' : navigator.language.startsWith('es') ? 'es' : 'en';
  const UI = placeholdersIdiomas[currentLang];

  if (logado || postVindoDoLink) {
    return <Feed postParaAbrirLink={postVindoDoLink} />;
  }

    return (
    <div className="login-container" style={{ 
            paddingTop: 'calc(env(safe-area-inset-top) + 40px)',
      paddingBottom: 'calc(env(safe-area-inset-bottom) + 40px)',
      paddingLeft: 'calc(env(safe-area-inset-left) + 20px)',
      paddingRight: 'calc(env(safe-area-inset-right) + 20px)',
      minHeight: '100dvh', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      boxSizing: 'border-box'
    }}>
      
      {/* TOPO COM LOGO E TEXTO - BLINDADO CONTRA TRADUTORES */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginTop: '10px', marginBottom: '15px' }}>
        <img src={logo} alt="Logo" style={{ width: '70px', height: 'auto', objectFit: 'contain' }} />
        <div style={{ textAlign: 'left', lineHeight: '1' }} translate="no" className="notranslate">
          <h1 style={{ color: '#39FF14', fontSize: '22px', margin: 0, fontWeight: 'bold' }}>GAME FUT</h1>
          <h1 style={{ color: 'white', fontSize: '22px', margin: 0, fontWeight: 'bold' }}>LIVE</h1>
        </div>
      </div>
      
            {!modoLogin && ( 
        <div className="profile-section" style={{ marginTop: '10px', marginBottom: '15px' }}>
          <label htmlFor="upload-foto" className="photo-label">
            <div className="photo-circle" style={{ width: '70px', height: '70px', margin: '0 auto', backgroundImage: `url(${fotoPreview})`, backgroundSize: 'cover' }}>
              {!fotoPreview && <span style={{fontSize: '20px'}}>+</span>}
            </div>
            <input type="file" id="upload-foto" accept="image/*" onChange={selecionarFoto} hidden />
          </label>
          <p style={{ color: 'white', fontSize: '8px', marginTop: '2px' }}>{UI.fotoPerfil}</p>
        </div>
      )}

      <div style={{ width: '100%', maxWidth: '320px' }}>
        {!modoLogin && ( 
          <input 
            type="text" 
            placeholder={UI.nickname} 
            className="neon-input" 
            value={nomeCompleto} 
            onChange={(e) => setNomeCompleto(e.target.value)} 
            style={{ padding: '12px', fontSize: '14px', width: '100%', marginBottom: '15px', boxSizing: 'border-box' }} 
          />
        )}

        <input 
          type="email" 
          placeholder={UI.email} 
          className="neon-input" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
          style={{ padding: '12px', fontSize: '14px', width: '100%', marginBottom: '10px', boxSizing: 'border-box' }} 
        />

        <div style={{ position: 'relative', width: '100%' }}>
          <input 
            type={mostrarPassword ? "text" : "password"} 
            placeholder={UI.password} 
            className="neon-input" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            style={{ padding: '12px', fontSize: '14px', width: '100%', marginBottom: '15px', boxSizing: 'border-box' }} 
          />
          <span 
            onClick={() => setMostrarPassword(!mostrarPassword)}
            style={{
              position: 'absolute', right: '15px', top: '12px', 
              cursor: 'pointer', color: '#39FF14', fontSize: '18px',
              zIndex: 10
            }}
          >
            {mostrarPassword ? "👁️‍🗨️" : "👁"}
          </span>
        </div>

        {!modoLogin && ( 
          <>
            <label style={{ color: '#39FF14', fontSize: '11px', display: 'block', marginBottom: '5px' }}>{UI.dataNasc}</label>
            <input type="date" className="neon-input" onChange={(e) => verificarIdade(e.target.value)} style={{ color: 'white', padding: '12px', width: '100%', fontSize: '14px', boxSizing: 'border-box' }} />
            
            <p style={{ color: erroIdade ? '#ff4d4d' : '#666', fontSize: '9px', textAlign: 'center', margin: '8px 0', fontWeight: 'bold' }}>
              {erroIdade ? UI.menorIdade : UI.maiorIdade}
            </p>
          </> 
        )}
      </div>

      <button 
        className="enter-btn" 
        onClick={entrarNoJogo} 
        disabled={carregando || (modoLogin ? (email.length < 3 || password.length < 6) : (!nomeCompleto || !fotoFicheiro || erroIdade))}
                style={{ 
          marginTop: '15px', 
          width: '100%', 
          maxWidth: '320px', 
          padding: '15px', 
          fontSize: '14px', 
          fontWeight: 'bold',
          opacity: (carregando || (!modoLogin && (erroIdade || !nomeCompleto || !fotoFicheiro))) ? 0.5 : 1
        }}
      >
        {carregando ? UI.processar : UI.confirmar}
      </button>

          <p 
        onClick={() => window.open('https://gamefutlive.com', '_blank')}
        style={{ color: '#666', cursor: 'pointer', marginTop: '20px', fontSize: '11px', textAlign: 'center', textDecoration: 'underline' }}
      >
        {UI.termosUso}
      </p>

      <p 
        onClick={() => setModoLogin(!modoLogin)} 
        style={{ color: '#39FF14', cursor: 'pointer', marginTop: '20px', fontSize: '13px', fontWeight: 'bold' }}
      >
        {modoLogin ? UI.criarConta : UI.entrarEstadio}
      </p>

      {modoLogin && (
        <p 
          onClick={recuperarSenha}
          style={{ color: '#666', cursor: 'pointer', fontSize: '11px', marginTop: '10px' }}
        >
          {UI.esqueciSenha}
        </p>
      )}

      {promptInstalacao && (
        <div style={{
          position: 'fixed', 
          top: '0', 
          left: '0',
          width: '100%', 
          background: '#111', 
          borderBottom: '2px solid #39FF14', 
          padding: '10px', 
          zIndex: 10000,
          textAlign: 'center',
          boxSizing: 'border-box'
        }}>
          <p style={{ color: 'white', margin: '0 0 5px 0', fontSize: '12px', fontWeight: 'bold' }}>
            {UI.instalarTitulo}
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button 
              onClick={instalarApp}
              style={{
                background: '#39FF14', color: 'black', border: 'none',
                padding: '8px 15px', borderRadius: '8px', fontWeight: 'bold',
                fontSize: '12px', cursor: 'pointer'
              }}
            >
              {UI.instalarBotao}
            </button>
            <button 
              onClick={() => setPromptInstalacao(null)}
              style={{
                background: 'transparent', color: '#666', border: '1px solid #333',
                padding: '8px 15px', borderRadius: '8px', fontSize: '12px'
              }}
            >
              {UI.instalarMaisTarde}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;

